import { findAndReplace } from "mdast-util-find-and-replace";
import { u } from "unist-builder";
import { foundryObjectType } from "../src/config/foundry";

export const OBJECT_REFERENCE_REGEX =
  /:objectreference\[(.+?)\]{objectType="([^"]+)" primaryKey="([^"]+)"?}/g;

export default function foundryMarkdown() {
  // type is mdast.Nodes, but importing that causes high severity security flaws.
  /* eslint @typescript-eslint/no-explicit-any: off */
  return function (tree: any) {
    /**
     * This replaces Foundry's object references, which have the form:
     *   :objectreference[(LINK TEXT)]{objectType="<ontology-prefix>.event" primaryKey="665d8325-eaa5-4b79-a07c-426faf10f919"}
     * and replaces them with an HTML anchor tag linking to the right
     * page. When rendering, this is then replaced again with a <Link>
     * component to get single page app behaviour.
     *
     * Note that sometimes the closing quotation is missing, so we
     * make that optional.
     */
    findAndReplace(tree, [
      [
        OBJECT_REFERENCE_REGEX,
        (_, text: string, objectType: string, primaryKey: string) => {
          const makeUrl = appConfig[objectType];
          if (makeUrl) {
            return u("link", { url: makeUrl(primaryKey) }, [u("text", text)]);
          } else {
            console.warn("Unknown object type", objectType);
            return u("text", text);
          }
        },
      ],
    ]);
  };
}

interface FoundryMarkdownConfig {
  [index: string]: ((primaryKey: string) => string) | undefined;
}

function makeAppUrl(objectTypePath: string): (primaryKey: string) => string {
  return (primaryKey) => `/${objectTypePath}/` + encodeURIComponent(primaryKey);
}

const appConfig: FoundryMarkdownConfig = {
  [foundryObjectType("event")]: makeAppUrl("event"),
  [foundryObjectType("country")]: makeAppUrl("country"),
  [foundryObjectType("person")]: makeAppUrl("person"),
  [foundryObjectType("organization")]: makeAppUrl("organization"),
};
